import { Component, Suspense } from "react";
import { useLocation } from "react-router-dom";

class ModuleError extends Component {
    state = { failed: false };
    static getDerivedStateFromError() { return { failed: true }; }
    render() {
        if (this.state.failed) return <div className="supply-empty" role="alert">
            <p>Impossible de charger cette page. Verifiez votre connexion.</p>
            <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}><i className="bx bx-refresh me-2" />Recharger</button>
        </div>;
        return this.props.children;
    }
}

export default function ModuleBoundary({ children }) {
    const { pathname } = useLocation();
    return <ModuleError key={pathname}>
        <Suspense fallback={<div className="soma-loading-state" role="status"><span className="soma-loader-ring" /><strong>Chargement...</strong></div>}>
            {children}
        </Suspense>
    </ModuleError>;
}
